import { createSelector } from 'reselect';
import { selectInstoreOffers } from '../../OffersSection/selectors';

const GOOGLE_MAP_DIRECTION_PREFIX = 'https://www.google.com/maps?saddr=My+Location&daddr=';
const selectMapLocations = state => state.map;

export const selectInstoreLocationsConfig = createSelector(
  selectMapLocations,
  mapLocations => mapLocations.config,
);

export const selectInstoreLocationsIsLoading = createSelector(
  selectMapLocations,
  mapLocations => mapLocations.isLoading,
);

export const selectInstoreLocationsIsLoaded = createSelector(
  selectMapLocations,
  mapLocations => mapLocations.isLoaded,
);

export const selectInstoreLocations = createSelector(
  selectMapLocations,
  mapLocations => [...mapLocations.locations].map((location) => {
    const { standardizedAddress } = location;
    location.storeDirectionLink = GOOGLE_MAP_DIRECTION_PREFIX + standardizedAddress;
    return location;
  }),
);

export const selectInstoreLocation = createSelector(
  selectInstoreOffers,
  instoreOffers => {
    const { locationData } = instoreOffers;
    return locationData;
  },
);

export const selectInstoreZipcode = createSelector(
  selectInstoreOffers,
  instoreOffers => {
    const { currentZipcode } = instoreOffers;
    return currentZipcode;
  },
);

export const selectUserLocation = createSelector(
  selectInstoreOffers,
  instoreOffers => {
    const { userLocation } = instoreOffers;
    return userLocation;
  },
);
